var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#828292",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 12C0.375 5.57812 5.57812 0.375 12 0.375C18.4219 0.375 23.625 5.57812 23.625 12C23.625 18.4219 18.4219 23.625 12 23.625C5.57812 23.625 0.375 18.4219 0.375 12ZM21.375 12C21.375 6.82031 17.1797 2.625 12 2.625C6.82031 2.625 2.625 6.82031 2.625 12C2.625 17.1797 6.82031 21.375 12 21.375C17.1797 21.375 21.375 17.1797 21.375 12ZM7.5 8.25V15.75C7.5 16.1625 7.8375 16.5 8.25 16.5H15.75C16.1625 16.5 16.5 16.1625 16.5 15.75V8.25C16.5 7.8375 16.1625 7.5 15.75 7.5H8.25C7.8375 7.5 7.5 7.8375 7.5 8.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecord);
export default __webpack_public_path__ + "static/media/Record.fd03214b.svg";
export { ForwardRef as ReactComponent };